import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const tokenReadySlice = createSlice({
    name: 'tokenReady',
    initialState: false,
    reducers: {
        update: (state, action) => action.payload ?? state,
        reset: (state, action) => [],
    },
});

export const { update, reset } = tokenReadySlice.actions;

export default tokenReadySlice.reducer;
